import SpectrumCardHoverable from "./SpectrumCardHoverable";
import styles from "./spectraArray.module.css";

const SpectraArrayHoverable = ({
  data,
  featureId,
  showProbability = false,
}) => {
  const content = data?.map((row) => {
    const isBareId = typeof row === "string";
    const spectrumId = isBareId ? row : row?.spectrum?.id ?? row?.id;
    if (!spectrumId) return null;
    return (
      <SpectrumCardHoverable
        key={spectrumId}
        id={spectrumId}
        spectrumData={isBareId ? null : row?.spectrum}
        value={isBareId ? undefined : row?.value}
        lastEditAt={isBareId ? null : row?.last_edit_at}
        labelSource={isBareId ? null : row?.label_source}
        probability={isBareId ? undefined : row?.probability}
        inferenceState={isBareId ? undefined : row?.inference_state}
        showProbability={showProbability}
        featureId={featureId}
      />
    );
  });

  return <div className={styles.spectraArray}>{content}</div>;
};

export default SpectraArrayHoverable;
